module.exports = __webpack_public_path__ + "img/kefu.66852c65.png";